<template>
  <div class="full-width">
    <div class="home-banner-area mb-4 pt-3">
      <div class="container">
        <div class="row gutters-10 position-relative">
          <div
            class="col-lg-3 position-static d-none d-lg-block"
            style="height: 451px;"
          >
            <div
              class="aiz-category-menu bg-white rounded shadow-sm"
              style="height: 100%;overflow-y: scroll;"
            >
              <div
                class="p-3 bg-soft-primary d-none d-lg-block rounded-top all-category position-relative text-left"
              >
                <span class="fw-600 fs-16 mr-3">{{ $t("类别") }}</span>
                <router-link class="text-reset" to="/categories">
                  <span class="d-none d-lg-inline-block"
                    >{{ $t("查看所有") }} &gt;</span
                  >
                </router-link>
              </div>
              <ul
                class="list-unstyled categories no-scrollbar py-2 mb-0 text-left"
              >
                <li
                  v-for="cate in cates"
                  :key="cate.id"
                  class="category-nav-element"
                  data-id="1"
                >
                  <router-link
                    :to="categoryUrl(cate)"
                    class="text-truncate text-reset py-2 px-3 d-block"
                  >
                    <img
                      :src="getFileViewUrl(cate.pic)"
                      alt=""
                      class="cat-image mr-2 opacity-60 ls-is-cached lazyloaded"
                      width="16"
                    />
                    <span class="cat-name">{{ $t(cate.name) }}</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-9">
            <div
              class="aiz-carousel dots-inside-bottom mobile-img-auto-height slick-initialized slick-slider slick-dotted"
            >
              <button
                class="slick-prev slick-arrow"
                type="button"
                @click="prev"
              >
                <i class="las la-angle-left"></i>
              </button>
              <van-swipe
                ref="swipe"
                :autoplay="3000"
                class="my-swipe"
                @change="onChange"
              >
                <van-swipe-item
                  v-for="(banner, index) in banner_list"
                  :key="index"
                >
                  <img
                    :src="getFileViewUrl(banner.pic)"
                    alt=""
                    class="d-block mw-100 img-fit rounded shadow-sm overflow-hidden"
                    height="315"
                    @click="jump(banner.url)"
                  />
                </van-swipe-item>
                <template #indicator>
                  <ul class="slick-dots">
                    <li
                      v-for="index of banner_list.length"
                      :key="index"
                      :class="{ 'slick-active': current === index }"
                    >
                      <button role="tab" tabindex="-1" type="button" />
                    </li>
                  </ul>
                </template>
              </van-swipe>
              <button
                class="slick-next slick-arrow"
                type="button"
                @click="next"
              >
                <i class="las la-angle-right"></i>
              </button>
            </div>

            <ul class="list-unstyled mb-0 row gutters-5">
              <li
                v-for="(cate, i) in cates.slice(0, 9)"
                :key="i"
                class="minw-0 col-4 col-md mt-3"
                @click="jump(categoryUrl(cate))"
              >
                <a class="d-block rounded bg-white p-2 text-reset shadow-sm">
                  <img
                    :src="getFileViewUrl(cate.pic)"
                    alt=""
                    class="img-fit ls-is-cached lazyloaded"
                    height="78"
                  />
                  <div class="text-truncate text-center fs-12 fw-600 mt-2 opacity-70">
                    {{ $t(cate.name) }}
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <PosterList :poster-list="posterList1" />

    <TitleSlide v-if="discountProducts.length" :list="discountProducts" :title="$t('限时优惠')" :button-name="$t('查看更多')" button-href="/category?buyDiscountWhere=%23ne%23100"/>
    <TitleSlide :list="featuredProducts" :title="$t('特色产品')" />
    <!--     todo 跳转到卖的最好的页面-->
    <TitleSlide
      :button-name="$t('前_名', [20])"
      :list="bestSelling"
      :title="$t('最畅销')"
    />

    <PosterList :poster-list="posterList2" />

    <TitleSlide
      v-for="(item, index) in cateGoodsList"
      :key="index"
      :button-href="categoryUrl(item.cate)"
      :button-name="$t('查看更多')"
      :list="item.goods"
      :title="$t(item.cate.name)"
    />

    <PosterList :poster-list="posterList3" />

    <SectionBestSellers v-if="'1' === paramMapAll['SHOP_HOME_SHOW_SELLER']" />

    <section class="mb-4">
      <div class="container">
        <div class="row gutters-10">
          <div
            :class="{
              'col-lg-6': brands.length,
              col: !brands.length
            }"
          >
            <SectionCategories
              :button-name="$t('查看所有类别')"
              :list="cates.slice(0, 10)"
              :title="$t('前_名类别', [10])"
              button-href="/categories"
            />
          </div>
          <div v-if="brands.length" class="col-lg-6">
            <SectionCategories
              :button-name="$t('查看所有品牌')"
              :list="brands"
              :title="$t('十大品牌')"
              button-href="/brands"
            />
          </div>
        </div>
      </div>
    </section>
    <div class="container mb-4">
    <div
            class="aiz-carousel dots-inside-bottom mobile-img-auto-height slick-initialized slick-slider slick-dotted"
        >
          <button
              class="slick-prev slick-arrow"
              type="button"
              @click="prev"
          >
            <i class="las la-angle-left"></i>
          </button>
          <van-swipe
              ref="swipe"
              :autoplay="3000"
              class="my-swipe"
              @change="onChange"
          >
            <van-swipe-item
                v-for="(banner, index) in banner_list_bottom"
                :key="index"
            >
              <img
                  :src="getFileViewUrl(banner.pic)"
                  alt=""
                  class="d-block mw-100 img-fit rounded shadow-sm overflow-hidden"
                  height="315"
                  @click="jump(banner.url)"
              />
            </van-swipe-item>
            <template #indicator>
              <ul class="slick-dots">
                <li
                    v-for="index of banner_list_bottom.length"
                    :key="index"
                    :class="{ 'slick-active': current === index }"
                >
                  <button role="tab" tabindex="-1" type="button" />
                </li>
              </ul>
            </template>
          </van-swipe>
          <button
              class="slick-next slick-arrow"
              type="button"
              @click="next"
          >
            <i class="las la-angle-right"></i>
          </button>
    </div>
    </div>
  </div>
</template>

<script>
import TitleSlide from "@/components/TitleSlide.vue";
import SectionBestSellers from "@/components/SectionBestSellers.vue";
import SectionCategories from "@/components/SectionCategories.vue";
import { getBannerList } from "@/api/sys/common";
import { getListCates } from "@/api/goods";
import PosterList from "@/components/PosterList.vue";
import { getBrandList } from "@/api/storeBrand";

export default {
  name: "HomeView",
  components: {
    PosterList,
    SectionCategories,
    SectionBestSellers,
    TitleSlide
  },
  data() {
    return {
      // showSeller: true,

      current: 1,
      banner_list: [],
      banner_list_bottom: [],
      cates: [],

      posterList1: [],
      posterList2: [],
      posterList3: [],

      featuredProducts: [],
      discountProducts: [],
      bestSelling: [],
      cateGoodsList: [],
      randomMulti: parseInt(Math.random() * new Date().getTime()) % 100000,

      brands: []
    };
  },
  methods: {
    onChange(index) {
      this.current = index + 1;
    },
    prev() {
      this.$refs.swipe.prev();
    },
    next() {
      this.$refs.swipe.next();
    },
    async getPoster(type) {
      const res = await getBannerList(`${type}`);
      return res.data;
    },
    async getFeaturedProducts() {
      // todo 现有办法不能查询到所谓featuredProducts
      const params = {
        orders: [
          // {column: "userShopGoods_storeGoods.create_time", asc: false},
          // { column: "userShopGoods_storeGoods.id", asc: false }
        ],
        randomMulti: parseInt(this.randomMulti * (Math.random() + 0.25)),
        curPage: 1,
        pageSize: 10
      };
      const page = (await this.$get("/goods/page", { params })).data;
      return page.records;
    },
    async getDiscountProducts() {
      if (this.paramMapAll['HOME_DISCOUNT_GOODS_CLOSE'] === '1') return []
      const params = {
        orders: [
          // {column: "userShopGoods_storeGoods.create_time", asc: false},
          // { column: "userShopGoods_storeGoods.id", asc: false }
        ],
        randomMulti: parseInt(this.randomMulti * (Math.random() + 0.25)),
        buyDiscountWhere: '#ne#100',
        curPage: 1,
        pageSize: 10
      };
      const page = (await this.$get("/goods/page", { params })).data;
      return page.records;
    },
    async getBestSelling() {
      const params = {
        orders: [
          { column: "sales", asc: false }
          // { column: "userShopGoods_storeGoods.id", asc: false }
        ],
        // randomMulti: this.randomMulti,
        curPage: 1,
        pageSize: 10
      };
      const page = (await this.$get("/storeGoods/selectPages", { params }))
        .data;
      return page.records;
    },
    async getCateList() {
      const res = await getListCates({ showInHomeFlag: 1 });
      const cates = res.data;
      Promise.all(cates.map(cate => this.getCateProducts(cate))).then(
        dataList => {
          this.cateGoodsList = dataList;
        }
      );
    },
    async getCateProducts(cate) {
      const params = {
        goodsCateCode: cate.code,
        randomMulti: this.randomMulti,
        pageSize: 10,
        curPage: 1
      };
      const page = (await this.$get("/goods/page", { params })).data;
      return { cate, goods: page.records };
    },
    async getBrands() {
      const res = await getBrandList({ showInHomeFlag: 1 });
      this.brands = res.data.map(item => {
        item.to = `/brand?brandCode=${item.code}&brandName=${item.name}`;
        return item;
      });
    }
  },
  created() {
    getBannerList("1").then(res => {
      this.banner_list = res.data
    });
    getBannerList("home_bottom").then(res => {
      this.banner_list_bottom = res.data
    });
    getListCates().then(res => {
      this.cates = res.data.map(item => {
        item.to = this.categoryUrl(item);
        return item;
      });
    });
    this.getPoster("home_ad1").then(res => (this.posterList1 = res));
    this.getPoster("home_ad2").then(res => (this.posterList2 = res));
    this.getPoster("home_ad3").then(res => (this.posterList3 = res));
    this.getFeaturedProducts().then(res => (this.featuredProducts = res));
    this.getDiscountProducts().then(res => (this.discountProducts = res));
    this.getBestSelling().then(res => (this.bestSelling = res));
    this.getCateList();
    this.getBrands();
  }
};
</script>
<style lang="scss">
.my-swipe img {
  -webkit-backface-visibility: hidden;
  -webkit-transform: scale(1);
  transition: transform 0.3s ease;
}
.my-swipe {
  overflow: hidden;
}



</style>

